import api from "./api";

export type AuditAction = "Create" | "Update" | "Delete" | string;

export interface FieldChange {
  old: any;
  new: any;
}

export interface AuditLog {
  id: string;
  performedById?: string;
  performedByName?: string;
  performedByEmail?: string;
  userRole: string;
  category?: string;
  entityType: string;
  entityId?: string;
  entityName?: string;
  action: AuditAction;
  shortDescription?: string;
  changes?: Record<string, FieldChange> | null;
  details?: any;
  formattedDateTime?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface AuditLogListParams {
  page?: number;
  limit?: number;
  dateFrom?: string;
  dateTo?: string;
  performedBy?: string;
  userRole?: string;
  category?: string;
  entityType?: string;
  action?: string;
  fieldName?: string;
  search?: string;
}

export interface AuditLogListResponse {
  auditLogs: AuditLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

const BASE = "/api/super-admin/audit-logs";

export const listAuditLogs = async (params?: AuditLogListParams): Promise<AuditLogListResponse> => {
  const { data } = await api.get(BASE, { params });
  return data.data;
};

export const exportAuditLogs = async (
  params?: AuditLogListParams,
  format: "excel" | "pdf" = "excel"
): Promise<void> => {
  const response = await api.get(`${BASE}/export`, {
    params: { ...params, format },
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: format === "pdf" ? "application/pdf" : "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const fileExt = format === "pdf" ? "pdf" : "csv";
  link.setAttribute("download", `Audit_Logs_${new Date().toISOString().slice(0, 10)}.${fileExt}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
